import * as queryString from 'query-string';
import { useState } from 'react';
import useRouter from 'use-react-router';
import {
  isCampaignKind,
  isTimeKind,
  UIFilterCampaignKindType,
  UIFilterCampaignTimeType,
} from './types';

const parseKind = (search: string): UIFilterCampaignKindType => {
  const { kind } = queryString.parse(search);
  return isCampaignKind(kind) ? kind : 'chat_blaster';
};

const parseTime = (search: string): UIFilterCampaignTimeType | undefined => {
  const { time } = queryString.parse(search);
  return isTimeKind(time) ? time : undefined;
};

const parseSearch = (search: string): string | undefined => {
  const { search: parsedSearch } = queryString.parse(search);
  return typeof parsedSearch === 'string' ? parsedSearch : undefined;
};

export const useCampaignsFilters = () => {
  const { history, location } = useRouter();
  const { search } = location;
  const activeKind = parseKind(search);
  const activeTime = parseTime(search);
  const activeSearch = parseSearch(search);
  const [doSearch, setDoSearch] = useState(false);

  const setSearchParams = (params: Record<string, any>) => {
    const searchParams = queryString.parse(search);
    history.push({
      ...location,
      search: queryString.stringify({ ...searchParams, ...params }),
    });
  };

  const setFilterKind = (kind?: UIFilterCampaignKindType) =>
    setSearchParams({ kind, search: undefined });

  const setFilterTime = (time?: UIFilterCampaignTimeType) =>
    setSearchParams({ time });

  const setSearchQuery = (search: string) => {
    setDoSearch(true);
    setSearchParams({ search: search || undefined });
  };

  return {
    activeKind,
    activeTime,
    activeSearch,
    setFilterKind,
    setFilterTime,
    setSearchQuery,
    doSearch,
    setDoSearch,
  };
};
